import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogComponent } from '@comparit/core';
import type { ErgebnisInput } from '../../interfaces/ergebnis-input.model';
import { ResultsBaseService } from '../../services/results-base.service';

/** Opened by the page when the funnel is incomplete; sends the customer to the first invalid step. */
@Component({
  selector: 'ui-invalid-eingaben-dialog',
  templateUrl: './invalid-eingaben-dialog.component.html',
  styleUrl: './invalid-eingaben-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogComponent, MatButtonModule],
})
export class InvalidEingabenDialogComponent {
  private readonly dialogRef = inject(MatDialogRef);
  private readonly router = inject(Router);
  private readonly results: ResultsBaseService<unknown, ErgebnisInput> = inject(ResultsBaseService);

  protected zuMeinenEingaben(): void {
    this.dialogRef.close();
    this.router.navigateByUrl(this.results.firstInvalidStepUrl());
  }
}
